import { Link, LinkProps, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { isUrlActive } from '@common/utils/urlMatcher';
import styles from '@styles';

interface AppLinkProps extends LinkProps {
    to: string;
    pattern?: string;
    end?: boolean;
    isActive?: boolean;
}

export const AppLink = ({
    to,
    pattern,
    end,
    isActive: injectedIsActive,
    children,
    className = undefined,
    ...props
}: AppLinkProps) => {
    const { pathname, search } = useLocation();

    const isActive =
        injectedIsActive ??
        isUrlActive({
            pathname,
            search,
            targetTo: to,
            pattern,
            end,
        });

    return (
        <Link
            className={classNames(styles.link, className)}
            {...props}
            to={to}
            data-state={isActive ? 'active' : 'inactive'}
            aria-current={isActive ? 'page' : undefined}
        >
            {children}
        </Link>
    );
};
